/**
 * Centralized environment configuration.
 * Single source of truth for the API base URL and the mock-data toggle,
 * so the axios instance, file uploader, and MSW handlers stay in sync.
 */

function parseBoolean(value: string | undefined, fallback = false): boolean {
  if (value === undefined) return fallback;
  return value === 'true' || value === '1';
}

export type AppMode = 'test' | 'stage' | 'prod';

export const env = {
  /** Active app mode: test | stage | prod. */
  mode: (import.meta.env.VITE_MODE as AppMode) || 'test',
  /** API base URL. Version prefix (e.g. /v1/admin) is added per endpoint. */
  apiBaseUrl: import.meta.env.VITE_API_URL || 'https://new-api-test.vasit.uz/api',
  /** When true, the app serves mock data (MSW) instead of calling the real API. */
  useMock: parseBoolean(import.meta.env.VITE_USE_MOCK),
} as const;
